export default __webpack_public_path__ + "static/media/vanPhongImg5.c06c5af0.jpeg";